import React, { useEffect, useState } from 'react';
import { Select, Form, Button, Row, Col } from 'antd';
import moment from 'moment';
import 'moment/locale/zh-cn';
moment.locale('zh-cn');

const ModalBody1 = ({close, handleSubmit1}) => {
    const [form] = Form.useForm();
    const [selectedFile, setSelectedFile] = useState(null);

    const changeHandler = (evt) => {
      setSelectedFile(evt.target.files[0]);
    }

    const onFinish = (values) => {
        handleSubmit1({
            file: selectedFile
        })
    }

    return (
        <Form onFinish={onFinish} form={form}>
            <div className="form form--horizontal">
                <Row gutter={16} style={{width: '100%'}}>
                    <Col span={24}>
                      <input type="file" name="file" onChange={changeHandler} ></input>
                    </Col>
                </Row>
            </div>    
            <Row style={{justifyContent: 'center', marginTop: '32px'}}>
                <Button type="text" onClick={close}>Cancel</Button>
                <Button type="primary" htmlType="submit">Import</Button>
            </Row>
        </Form>
        
    )
}

export default ModalBody1;